import type { QueryResponse } from "../../../../shared/contracts/query";

export type ClarifyingQuestionData = NonNullable<QueryResponse["nextQuestion"]>;
export type ClarifyingAnswerValue = string | boolean;

export type ClarifyingQuestionProps = {
  question: ClarifyingQuestionData;
  onAnswer: (attribute: string, value: ClarifyingAnswerValue) => void;
  pending?: boolean;
};

function answerValue(attribute: string, option: string): ClarifyingAnswerValue {
  if (attribute === "codeCountry") {
    if (option === "CN" || option.includes("中国")) return "CN";
    if (option === "US" || option.includes("美国")) return "US";
    if (option === "CA" || option.includes("加拿大")) return "CA";
  }
  if (option === "是") return true;
  if (option === "否") return false;
  if (option === "不清楚" || option === "不确定") return "unknown";
  return option;
}

export function ClarifyingQuestion({ question, onAnswer, pending = false }: ClarifyingQuestionProps) {
  const headingId = `clarifying-question-${question.id}`;
  const options = question.options.slice(0, 3);

  return (
    <section className="question-panel clarifying-question" aria-labelledby={headingId}>
      <p className="eyebrow">需要确认</p>
      <h2 id={headingId}>{question.label}</h2>
      <div className="question-options" role="group" aria-label="确认选项">
        {options.map((option) => (
          <button
            type="button"
            key={option}
            disabled={pending}
            onClick={() => onAnswer(question.attribute, answerValue(question.attribute, option))}
          >
            {option}
          </button>
        ))}
      </div>
      {pending ? <p className="question-loading" role="status" aria-live="polite">正在处理…</p> : null}
    </section>
  );
}
